import script from "./qualifications-audit.vue?vue&type=script&lang=tsx&setup=true"
export * from "./qualifications-audit.vue?vue&type=script&lang=tsx&setup=true"

import "./qualifications-audit.vue?vue&type=style&index=0&id=cce38864&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cce38864"]])

export default __exports__